import Vue from 'vue';
import { registerMicroApps, start, setDefaultMountApp } from 'qiankun';
import {
    Menu,
    Loading,
    MenuItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Form,
    FormItem,
    Input,
    Row,
    Col,
    Popover,
    Submenu,
} from 'element-ui';

import DapComponents from '@dap/base-comp';
import DapUi from '@lilith/dap-ui';
import watermark from 'watermark-dom';

import App from './App.vue';
import router from './router';
import store from './store';

import 'element-ui/packages/theme-chalk/src/index.scss';
import 'element-ui/lib/theme-chalk/display.css';
import './styles/app.scss';

Vue.config.productionTip = false;
Vue.prototype.$ELEMENT = { size: 'small' };

const elementUIComponents = [
    Menu,
    MenuItem,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Form,
    FormItem,
    Input,
    Row,
    Col,
    Popover,
    Submenu,
];

elementUIComponents.forEach((component) => Vue.use(component));

Vue.use(Loading.directive);
Vue.use(DapComponents);
Vue.use(DapUi);

/** ******* 基座监控子应用的Loading状态 start ******** */
const instance = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

function loader (loading) {
    if (instance && instance.$children) {
        instance.$children[0].isLoading = loading;
        // console.log('loader', instance.$children[0]);
    }
}
/** ******* 基座监控子应用的Loading状态 end******** */

const microApps = [
    {
        name: '@dap/dap-web',
        entry: process.env.NODE_ENV === 'production' ? '/@dap/dap-web/' : '//localhost:8090',
        container: '#subApp',
        activeRule: [
            '/settings',
            '/advertise',
            '/advertise-2',
            '/art-resource',
            '/help-center',
            '/error',
            // '/dap',
            '/home',
        ],
        // sandbox: {
        //   // 沙箱选项配置
        //   strictStyleIsolation: true,
        //   // 其他沙箱选项...
        // }
    },
    {
        name: '@dap/tools',
        entry: process.env.NODE_ENV === 'production' ? '/@dap/tools/' : '//localhost:8180',
        container: '#subApp',
        activeRule: ['/tools', '/tool-list'],
    },
    {
        name: '@dap/insight',
        entry: process.env.NODE_ENV === 'production' ? '/@dap/insight/' : '//localhost:8089',
        container: '#subApp',
        activeRule: '/table-2',
    },
    {
        name: '@dap/aigc',
        entry: process.env.NODE_ENV === 'production' ? `${window.location.origin}/@dap/aigc/` : '//localhost:8085',
        container: '#subApp',
        activeRule: '/aigc',
    },
    {
        name: '@dap/creative',
        entry: process.env.NODE_ENV === 'production' ? '/@dap/creative/' : '//localhost:8087',
        container: '#subApp',
        activeRule: ['/creative-center', '/creative-library'],
    },
    {
        name: '@dap/observatory',
        entry: process.env.NODE_ENV === 'production' ? '/@dap/observatory/' : '//localhost:8086',
        container: '#subApp',
        activeRule: '/observatory',
    },
    {
        name: '@dap/tools-ad-optimize',
        entry: process.env.NODE_ENV === 'production' ? `${window.location.origin}/@dap/tools-ad-optimize/` : '//localhost:8091',
        container: '#subApp',
        activeRule: '/tools-ad-optimize'
    },
];

/**
 * qiankun - 注册子应用
 */
registerMicroApps(
    microApps.map((microApp) => ({
        ...microApp,
        loader,
        props: {
            store,
        },
        // singular: true,
    }))
);

const startOptions = {
    prefetch: process.env.NODE_ENV === 'production',
};
// setDefaultMountApp('/dap');
// qiankun - 启动
start({
    prefetch: startOptions,
});

// 监听子应用路由变化
// window.addEventListener('qiankun-before-routing', (event) => {
//     const { childAppName, location } = event.detail;
//     console.log('childAppName', childAppName)
//     console.log('location', location)
//     // 处理子应用路由变化的逻辑
// });

// window.addEventListener('subAppLoaded', () => {
//     // 子应用加载成功的处理逻辑
//     console.log('Sub app loaded successfully!');
//     // 进行跳转或其他操作
//   });
